import axios from 'axios';
import { USER_BASE_URL } from '../API';
import { toast } from 'react-toastify';
import { clearAuthData } from './authService';

let isLoggingOut = false;
let token = localStorage.getItem('userToken');

const axiosInstance = axios.create({
    baseURL: USER_BASE_URL,
    headers: { 'Content-Type': 'application/json' }
});

axiosInstance.interceptors.request.use(
    (config) => {
        token = localStorage.getItem('userToken');
        if (token) { config.headers['Token'] = token }
        return config;
    },
    (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.data.error === "UNAUTHORIZED" && error.response.status === 401) {
            if (!token) return
            toast.error("Session expired. Please login again.");
            setTimeout(() => {
                clearAuthData();
                window.location.href = '/login';
            }, 1500);
        }
        return Promise.reject(error);
    }
);

export const resetLoggingOutFlag = () => { isLoggingOut = false };

export default axiosInstance;
